/* eslint-disable import/no-cycle */
import { MUTATION_REGISTER_SNAPSHOT_LISTENER, MUTATION_UNREGISTER_SNAPSHOT_LISTENER } from '@/shared/store/constants';
import { types as analysesTypes } from '@/shared/store/analyses';
import { types as analysesCaptureTypes } from '@/shared/store/analysesCapture';
import { types as userTypes } from '@/shared/store/user';
import { types as usersTypes } from '@/shared/store/users';
import { types as notificationsTypes } from '@/shared/store/notifications';
import { types as tagsTypes } from '@/shared/store/tags';
import { types as portfolioTypes } from '@/shared/store/portfolio';
import { types as bibliographyTypes } from '@/shared/store/bibliography';
import { types as portfolioTypesV2 } from '@/shared/store/portfolioV2';
import { types as aclEditorTypes } from '@/shared/store/aclEditor';
import { types as featureSwitchesTypes } from '@/shared/store/featureSwitches';
import { types as globalConfigTypes } from '@/shared/store/globalConfig';
import { types as authenticationTypes } from '@/shared/store/authentication';
import { types as uploadTypes } from '@/shared/store/upload';
import { types as templatesTypes } from '@/shared/store/templates';
import { types as sourcesTypes } from './sources';
import { types as displayTypes } from './display';
import { types as recommendationBasedJournalsTypes } from './recommendationBasedJournals';
import { types as reflectionsTypes } from './reflections';
import { types as uxTypes } from './ux';

export const ACTION_HANDLE_OPERATION_COMPLETION = 'handleOperationCompletion';
export const ACTION_UNSUBSCRIBE_SNAPSHOT_LISTENERS = 'unsubscribeSnapshotListeners';
export const MUTATION_SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const MUTATION_HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const GETTER_FIREBASE_PROJECT_ID = 'firebaseProjectId';
export const GETTER_VERSION = 'version';

export const types = {
  authentication: authenticationTypes,
  user: userTypes,
  users: usersTypes,
  analyses: analysesTypes,
  analysesCapture: analysesCaptureTypes,
  bibliography: bibliographyTypes,
  portfolio: portfolioTypes,
  portfolioV2: portfolioTypesV2,
  aclEditor: aclEditorTypes,
  notifications: notificationsTypes,
  tags: tagsTypes,
  sources: sourcesTypes,
  display: displayTypes,
  featureSwitches: featureSwitchesTypes,
  globalConfig: globalConfigTypes,
  recommendationBasedJournals: recommendationBasedJournalsTypes,
  reflections: reflectionsTypes,
  templates: templatesTypes,
  upload: uploadTypes,
  ux: uxTypes,
  actions: {
    handleOperationCompletion: ACTION_HANDLE_OPERATION_COMPLETION,
    unsubscribeSnapshotListeners: ACTION_UNSUBSCRIBE_SNAPSHOT_LISTENERS,
  },
  mutations: {
    SHOW_SNACKBAR: MUTATION_SHOW_SNACKBAR,
    HIDE_SNACKBAR: MUTATION_HIDE_SNACKBAR,
    REGISTER_SNAPSHOT_LISTENER: MUTATION_REGISTER_SNAPSHOT_LISTENER,
    UNREGISTER_SNAPSHOT_LISTENER: MUTATION_UNREGISTER_SNAPSHOT_LISTENER,
  },
};
